import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import graphqlClientFactory from 'lib/graphql-client-factory';
import {
  ArticleSearchRecentDocument,
  ArticleSearchRecentQueryVariables,
} from 'lib/services/queries/RecentArticles.graphql';
import { apiHost } from 'api/apiHost';

const graphQLClient = graphqlClientFactory();

export const articleApi = createApi({
  reducerPath: 'articleAPI',
  baseQuery: fetchBaseQuery({ baseUrl: `${apiHost}/api/funds` }), // should domain-based URL
  endpoints: (build) => ({
    getRecentArticles: build.query({
      queryFn: async (_arg) => {
        const result = await graphQLClient.request<ArticleSearchRecentQueryVariables>(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ArticleSearchRecentDocument as any,
          {
            siteId: _arg.siteId,
            language: _arg.language,
            contentGroupId: _arg.contentGroupId,
            pageSize: 8,
          }
        );
        return {
          data: result?.search.results,
        };
      },
    }),
  }),
});

export const { useLazyGetRecentArticlesQuery } = articleApi;
